import React from 'react';

import TableCell from 'components/@ui/TableCell';

const EmptyCell: React.FC = () => {
  return <TableCell width={16} sx={{ p: 0 }} />;
};

export default EmptyCell;
